export default {
  dataType: {
    DataIdentifier: 'Sygnał',
    MeaningIdentifier: 'Oznaczający',
  },
};
